module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ddqkH"))).then(() => parcelRequire('hEqeo'));